import React from 'react';
import { Quote } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { mockData } from '../../mock';

const ProgressStoriesSection = () => {
  const { progressStories } = mockData;

  return (
    <section
      id="testimonials"
      className="section-padding"
      data-testid="progress-stories-section"
    >
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">Real Progress, Real People</h2>
          <p className="section-subtitle">
            Evidence-based programs producing measurable, lasting outcomes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {progressStories.map((story) => (
            <Card
              key={`story-${story.id}`}
              className="testimonial-card"
              data-testid={`progress-story-${story.id}`}
            >
              <CardContent className="pt-6">
                <Quote
                  size={32}
                  className="text-brand-primary mb-4"
                  aria-hidden="true"
                  style={{ opacity: 0.6 }}
                />
                <p
                  style={{
                    fontSize: '0.8rem',
                    letterSpacing: '0.15em',
                    textTransform: 'uppercase',
                    color: 'var(--brand-accent, #FFD700)',
                    fontWeight: 700,
                    marginBottom: '0.5rem',
                  }}
                >
                  {story.outcome}
                </p>
                <p className="testimonial-quote">"{story.story}"</p>

                <ul
                  style={{
                    listStyle: 'none',
                    padding: 0,
                    margin: '1.25rem 0 0',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.4rem',
                  }}
                >
                  {story.metrics.map((metric) => (
                    <li
                      key={`story-${story.id}-${metric}`}
                      style={{
                        fontSize: '0.78rem',
                        padding: '0.3rem 0.65rem',
                        borderRadius: '999px',
                        background: 'rgba(29, 185, 84, 0.12)',
                        color: 'var(--brand-primary, #1DB954)',
                        border: '1px solid rgba(29, 185, 84, 0.3)',
                        fontWeight: 600,
                      }}
                    >
                      {metric}
                    </li>
                  ))}
                </ul>

                <div className="testimonial-author mt-6">
                  <div className="author-info">
                    <p className="author-name">{story.clientName}</p>
                    <p className="author-age">Age {story.age}</p>
                  </div>
                  <p className="author-result">{story.program}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgressStoriesSection;
